export default __webpack_public_path__ + "static/media/a037-student-t3-4.c30a6f85.svg";